var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent","height":"100%"}},_vm._l((_vm.components),function(component,id){return _c(component,{key:id,tag:"v-component"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }